window.Page = {

    slabs     : document.querySelectorAll('.product-picture'),
    menuItems : document.querySelectorAll('.products-navigation-item'),
    menuTitle : document.querySelector('.products-navigation-title'),

    // Let's launch this thing
    liftoff : () => {
        Page.animateImagesOnMouseMove()
        Page.updateMenuItemOnHover()
    },

    updateMenuItemOnHover : () => {

        Page.menuItems.forEach(menuItem => {
            menuItem.addEventListener('mouseleave' , () => {
                Page.menuTitle.classList.remove('is-visible')
                Page.menuTitle.innerHTML = null;
            })

            menuItem.addEventListener('mouseenter' , () => {
                Page.menuTitle.classList.add('is-visible')
                Page.menuTitle.innerHTML = menuItem.dataset.title;
            })
        })

    },

    // My new function block
    animateImagesOnMouseMove : () => {
        Page.slabs.forEach(slab => {

            slab.addEventListener('mouseenter' , () => { event.target.classList.add('is-moving') })
            slab.addEventListener('mouseleave' , () => { event.target.classList.remove('is-moving') })

            slab.addEventListener('mousemove' , (event) => {

                // We need to collect some data
                let x = event.layerX;
                let y = event.layerY;

                let width = event.target.clientWidth;
                let height = event.target.clientHeight;

                let xPer = 100 / width * x;
                let yPer = 100 / height * y;

                console.log(`X: ${xPer} — Y: ${yPer}`)

                // We need to calculate the transform values
                let xTransform = (20 / 100 * xPer) - 10;
                let yTransform = ((20 / 100 * yPer) - 10) * -1;

                // Time to set the transform value on the variables
                event.target.style.setProperty("--x", `${xTransform}deg`)
                event.target.style.setProperty("--y", `${yTransform}deg`)


            })

        })
    }

};

Page.liftoff()